<script>
import { Line } from "vue-chartjs";

export default {
    data() {
        return {
            chart: {
                labels: ["Jan", "Fed", "Mar", "Apr", "May", "Jun"],
                datasets: [
                    {
                        label: "Total Feedback",
                        data: [0, 0, 0, 0, 0, 0],
                        backgroundColor: "rgba(255, 99, 132, 0.4)",
                        borderColor: "rgba(255, 99, 132, 0.8)",
                        borderWidth: 2
                    }
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 2.4,
                legend: {
                    display: false
                },
                elements: {
                    point: {
                        radius: 1
                    },
                    line: {
                        tension: 0
                    }
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                stepSize: 20
                            },
                            gridLines: {
                                display: true
                            }
                        }
                    ]
                }
            },
            gradient: null
        };
    },
    props: ["data", "labels"],
    extends: Line,
    mounted() {
        this.gradient = this.$refs.canvas
            .getContext("2d")
            .createLinearGradient(0, 0, 0, 170);

        this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
        this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
        this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");
        this.chart.datasets[0].backgroundColor = this.gradient;
        this.renderChart(this.chart, this.options);
    },
    created() {},
    watch: {
        data: function(newValue, oldValue) {
            this.chart.datasets[0].data = newValue;
            this.renderChart(this.chart, this.options);
        },
        labels: function(newValue, oldValue) {
            this.chart.labels = newValue;
            this.renderChart(this.chart, this.options);
        }
    },
    methods: {}
};
</script>
